// extracted by mini-css-extract-plugin
module.exports = {"autosuggest":"AutoSuggest_autosuggest__3JH5d","autosuggestStatus":"AutoSuggest_autosuggestStatus__3YYWi","loader":"AutoSuggest_loader__4zmvm"};